import React from "react";

import "./Projects.css";

const Projects = () => {
	return (
		<section className="projects" id="projects">
			<h2 className="projects-title">My Projects</h2>
			<div className="projects-container">
				<div className="projo weather">
					<div className="projo-photo weather">
						<img src={require("./purges.PNG")} alt="weather app" />
					</div>
					<h4 className="projo-name">Weather App</h4>
					<p className="projo-skills">Skills: HTML, CSS, Javascript</p>
					<p className="projo-des">
						A weather app that makes use of the "weather api" api for data and
						shows information for upto seven different locations at a go. I went
						with a different look for this just to improve the UX and make it
						distinct. The app also has other features like the background
						refresher, show more and change city.
					</p>
					<a
						href="https://thepurgeweather.netlify.app/"
						target="blank"
						className="linking weather_link"
					>
						<button className="btn-check">View</button>
					</a>
				</div>

				<div className="projo to-do">
					<div className="projo-photo to-do">
						<img src={require("./mawe-karo-makasi.png")} alt="to-do app" />
					</div>
					<h4 className="projo-name">Rock-Paper-Scissors App</h4>
					<p className="projo-skills">
						Skills: HTML, CSS, Javascript, React, Redux Toolkit
					</p>
					<p className="projo-des">
						A rock-paper-scissors game with a different feel that has features
						such a data persistence and incorporates low-level competition
						between the User and computer(Eliud). This app has a number of
						applications but the most important one when I was setting it up is
						to keep the user occupied especially when they are waiting for data
						to load. The game incorporates Redux for state management.
					</p>
					<a
						href="https://mawe-karo-makasi.netlify.app"
						target="blank"
						className="linking to-do_link"
					>
						<button className="btn-check">View</button>
					</a>
				</div>
				<div className="projo budget">
					<div className="projo-photo budget">
						<img src={require("./gikosh-app.png")} alt="Gikosh-app" />
					</div>
					<h4 className="projo-name">Gikosh E-Commerce App</h4>
					<p className="projo-skills">
						Skills: HTML, CSS, Javascript, Typescript, React, Next.js, Redux
						Toolkit, Context API
					</p>
					<p className="projo-des">
						An e-commerce website built with Typescript and Next js and
						incorporates Redux Toolkit and Context Api for state management. The
						app has different pages built with Next's file based routing system
						and navigates the user all the way from viewing a product to
						purchasing it and making payments.
					</p>
					<a
						href="https://gikosh-nine.vercel.app"
						target="blank"
						className="linking budget_link"
					>
						<button className="btn-check">View</button>
					</a>
				</div>
				<div className="projo porfolio-site">
					<div className="projo-photo portfolio-site">
						<img src={require("./portfolio.PNG")} alt="portfolio" />
					</div>
					<h4 className="projo-name">Portfolio Site</h4>
					<p className="projo-skills">
						Skills: HTML, CSS, Javascript, React, Context API
					</p>
					<p className="projo-des">
						My portfolio site holds information about who I am, what I do and
						the tech stack I am into, where I have worked and also my skills.
						This app welcomes you to my world. Here, you get to know who Eliud
						the developer is and much more.
					</p>
					{/* <a href="/" className="linking portfolio-site_link">
						<button className="btn-check">View</button>
					</a> */}
				</div>
			</div>
		</section>
	);
};

export default Projects;
